import "./Evaluation.css"
import { useTranslation } from "react-i18next";
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

function Evaluation (props) {
    const { t } = useTranslation();

    //Ranking
    const numArray = [
        {
            step: 1,
            score: props.penAndPaperScore,
            color: ""
        },
        {
            step: 2,
            score: props.deductionsScore,
            color: ""
        },
        {
            step: 3,
            score: props.kpisScore,
            color: ""
        }
    ]
    numArray.sort(function(a, b) {
        return a.score - b.score;
    });

    for (let i=0; i < numArray.length; i++) {
        if (numArray[i].score === 1400) {
            numArray[i].color = "gold";
        } else {
            numArray[i].color = "silver";
        }
        if (i===1) {
            if (numArray[i].score === numArray[i-1].score) {
                numArray[i].color = numArray[i-1].color
            } else {
                numArray[i].color = "#bf8970"
            }
        }
        if (i===2) {
            if (numArray[i-1].score === numArray[i].score) {
                numArray[i].color = numArray[i-1].color;
            } else {
                numArray[i].color = "";
            }
        }
    }

    return (
        <div className="evaluation" id="evaluation">
            <h3>{t("evaluation")}</h3>
            <div className="stat">
                <p><span>1. {t("pnp")}</span></p>
                <div>
                    <p>
                        {t("score")}: <span name="score">{(props.penAndPaperScore) ? props.penAndPaperScore : "--"}</span>
                        {(props.penAndPaperScore && numArray[numArray.map((index) => index.step).indexOf(1)].color !== "") ? <WorkspacePremiumIcon sx={{color: numArray[numArray.map((index) => index.step).indexOf(1)].color, stroke: "black", marginLeft: "3px"}}></WorkspacePremiumIcon> : ""}
                    </p>
                    <p>{t("time_needed")} <span name="time"><span>{(props.penAndPaperMinutes) ? props.penAndPaperMinutes : "00"}</span><span>:</span><span>{(props.penAndPaperSeconds) ? ((props.penAndPaperSeconds === 0 || props.penAndPaperSeconds < 10) ? ("0" + props.penAndPaperSeconds) : props.penAndPaperSeconds) : "00"}</span></span> </p>
                </div>
            </div>
            <div className="stat">
                <p><span>2. {t("deductions")}</span></p>
                <div>
                    <p>
                        {t("score")}: <span name="score">{(props.deductionsScore) ? props.deductionsScore : "--"}</span>
                        {(props.deductionsScore && numArray[numArray.map((index) => index.step).indexOf(2)].color !== "") ? <WorkspacePremiumIcon sx={{color: numArray[numArray.map((index) => index.step).indexOf(2)].color, stroke: "black", marginLeft: "3px"}}></WorkspacePremiumIcon> : ""} 
                    </p>
                    <p>{t("time_needed")} <span name="time"><span>{(props.deductionMinutes) ? props.deductionMinutes : "00"}</span><span>:</span><span>{(props.deductionsSeconds) ? ((props.deductionsSeconds === 0 || props.deductionsSeconds < 10) ? ("0" + props.deductionsSeconds) : props.deductionsSeconds) : "00"}</span></span></p>
                </div>
            </div>
            <div className="stat">
                <p><span>3. {t("kpis")}</span></p>
                <div>
                    <p>
                        {t("score")}: <span name="score">{(props.kpisScore) ? props.kpisScore : "--"}</span>
                        {(props.kpisScore && numArray[numArray.map((index) => index.step).indexOf(3)].color !== "") ? <WorkspacePremiumIcon sx={{color: numArray[numArray.map((index) => index.step).indexOf(3)].color, stroke: "black", marginLeft: "3px"}}></WorkspacePremiumIcon> : ""} 
                    </p>
                    <p>{t("time_needed")} <span name="time"><span>{(props.kpisMinutes) ? props.kpisMinutes : "00"}</span><span>:</span><span>{(props.kpisSeconds) ? ((props.kpisSeconds === 0 || props.kpisSeconds < 10) ? ("0" + props.kpisSeconds) : props.kpisSeconds) : "00"}</span></span></p>
                </div>
            </div>
            <div className="stat">
                <p><span>4. {t("optimal")}</span></p>
                <div>
                    <p>
                        {t("score")}: <span>1400</span>
                        <WorkspacePremiumIcon sx={{color: "gold", stroke: "black", marginLeft: "3px"}}></WorkspacePremiumIcon>
                    </p>
                </div>
            </div>
            <br/>
            {props.button && <button className="evaluation-button" onClick={props.onClick}>{t("evaluationButton")}</button>}
        </div>
    );
}

export default Evaluation;